import React, { useCallback, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toastr } from 'react-redux-toastr';

import './style.css';

import iconTag from '../../../../../assets/images/icon_tag.svg';

const ModalEditTag = ({ isActive, initialData, onClose, onSubmit }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (initialData) {
      const { name } = initialData;
      setInputValue(name);
    }
  }, [isActive, initialData]);

  const handleInputChange = useCallback((e) => {
    if(e.target.value.includes(';')){
      setInputValue(e.target.value.replace(';', ''));
      toastr.error(
        'Erro',
        `Tags não podem conter ;`
      );
    }else{
      setInputValue(e.target.value);
    }
    
  }, []);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      onSubmit({ name: inputValue, id: initialData._id });
    },
    [onSubmit, inputValue, initialData]
  );

  return (
    <Modal
      show={isActive}
      onHide={onClose}
      className="modal-tag modal-content-tag"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <img src={iconTag} alt="Tag" /> Editar Tag
        </Modal.Title>
      </Modal.Header>

      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div>
            <input
              className="form-input"
              value={inputValue}
              onChange={handleInputChange}
              maxLength={50}
              required
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit">salvar</button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ModalEditTag;